export const styles = {
  textCenter: {
    textAlign: 'center',
  },
}
